<template>
	<div>
		<!--    搜索部分-->
		<el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
			<el-form-item label="所属代理商" :label-width="formLabelWidth" prop="agent" style="margin-bottom: 17px">
				<el-input placeholder="请选择" v-model="enquiryForm.agent" size="medium" :disabled="true">
					<el-button slot="append" @click="mechanismSearch">选择</el-button>
				</el-input>
			</el-form-item>

		</el-form>
    <div style="margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
      <el-button size="medium"  style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
      <el-button size="medium"  type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
    </div>
<!-- //打印 -->
			<prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
		<!--    表格部分-->
		<el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
			v-loading="loading" border id="tableDataId"  size="mini">
			<el-table-column header-align="center" align="center" prop="id" label="ID" sortable></el-table-column>
			<el-table-column header-align="center" align="center" prop="org_name" label="所属机构"></el-table-column>
			<el-table-column header-align="center" align="center" prop="creator" label="申请人"></el-table-column>
			<el-table-column header-align="center" align="center" prop="mobile_phone" label="申请人电话"></el-table-column>
			<el-table-column header-align="center" align="center" prop="coin" label="申请积分"></el-table-column>
			<el-table-column header-align="center" align="center" prop="create_time" label="提交时间"></el-table-column>
			<el-table-column header-align="center" align="center" prop="order_status" label="申请状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.order_status == '待处理'" type="info" disable-transitions>
            {{scope.row.order_status}}</el-tag>
          <el-tag v-if="scope.row.order_status == '已打款'" type="success" disable-transitions>
            {{scope.row.order_status}}</el-tag>
          <el-tag v-if="scope.row.order_status == '已拒绝'" type="danger" disable-transitions>
            {{scope.row.order_status}}</el-tag>
          <el-tag v-if="scope.row.order_status == '已驳回'" type="warning" disable-transitions>
            {{scope.row.order_status}}</el-tag>
        </template>
      </el-table-column>
			<el-table-column header-align="center" align="center" label="操作">
				<template slot-scope="scope" style="text-align: center;">
					<template v-if="scope.row.order_status=='待处理'?true:false">
						<el-button type="text" @click="agreed(scope.row)">同意</el-button>
						<el-button type="text" @click="overruled(scope.row)">驳回</el-button>
					</template>
				</template>
			</el-table-column>
			<el-table-column header-align="center" align="center" label="风控系统">
				<template slot-scope="scope" style="text-align: center;">
					<el-button type="text" @click="chInfo(scope.row)">查询风控系统</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页部分 -->
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[20,50,100,200,500,1000]" :page-size="page_size" :total="total"
			layout="total, sizes, prev, pager, next, jumper" style="text-align: right">
		</el-pagination>
		<!--      代理商选择表单部分-->
		<el-dialog v-if="mechanismVisible" title="配置表单" :visible.sync="mechanismVisible">
			<!--    搜索部分-->
			<el-form :inline="true" :model="dialogForm" class="demo-form-inline">
				<el-form-item label="名称">
					<el-input size="medium" clearable v-model="dialogForm.user_name" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input size="medium" clearable v-model="dialogForm.mobile_phone" placeholder="请输入"></el-input>
				</el-form-item>
					<el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch1(dialogForm)">搜索</el-button>
					<el-button size="medium"  style="font-size: 12px;" @click="handleSearch2(dialogForm)">重置</el-button>
			</el-form>
			<!--    表格部分-->
			<el-table height="250" :data="dialogData" style="width: 100%"
				:default-sort="{prop: 'date', order: 'descending'}" v-loading="loading2" border
				@row-click="singleElection">
				<el-table-column align="center" width="55">
					<template slot="header">
						<span style="cursor:pointer" @click="cancelClick2">取消</span>
					</template>
					<template slot-scope="scope">
						<el-radio class="radio" v-model="templateSelection" :label="scope.row.id">{{ '&nbsp;' }}
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="user_name" label="代理商名称">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="mobile_phone" label="代理商手机号">
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
				:page-sizes="[20,50,100,200,500,1000]" :page-size="page_size1" :total="dialogTotal"
				layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelDialog2">取 消</el-button>
				<el-button type="primary" @click="submitForm2">确 定</el-button>
			</div>
		</el-dialog>
		<!--    风控系统-->
		<el-dialog v-if="subordinateState" append-to-body title="查看风控系统" width="70%" :visible.sync="subordinateState">
			<subordinate-list :userId="subordinateId"></subordinate-list>
		</el-dialog>
	</div>
</template>

<script>
	import {
		export_json_to_excel
	} from "@/excel/Export2Excel";
	import subordinateList from "./subordinateList.vue"
	import prints from '@/components/print.vue'
	export default {
		components: {
			subordinateList,
			prints
		},
		name: "pointsExchangeOrder", //积分兑换订单页面
		data() {
			return {
				// 主页面部分
				loading: true, //列表loadding
				page_size: 20, //条数
				total: 0, //总数
				tableData: [], //表格数据
				enquiryForm: {
					page_size: 20,
					page: 1,
				},
				formLabelWidth: '80px',
				// 代理商表单部分
				loading2: true, //列表loadding
				page_size1: 20, //表单条数
				dialogTotal: 0, //表单总数
				dialogData: [], //表单数据
				mechanismVisible: false, //代理商选择表单开启
				dialogCodeVisible: false, //邀请码表单页面显示
				dialogForm: { //表单搜索数据
					page_size: 20,
					mobile_phone: "", //手机号码
					page: 1,
					user_name: "", //用户名称
				},
				//   当前选择的行的id
				templateSelection: "",
				//   当前选择的行的数据
				checkList: [],
				subordinateState: false, //查看风控系统
				subordinateId: null, //点击选择查看下级的id
				//打印
				tableTh: null,
				tableTd: null,
			}
		},
		created() {
			this.getData(this.enquiryForm)
			this.tableTh = ['ID', '所属机构', '申请人', '申请人电话', '申请积分', '提交时间'];
			this.tableTd = ['id', 'org_name', 'creator', 'mobile_phone', 'coin', 'create_time'];
			this.$nextTick(() => {
				this.$refs.prints.prints();
			})
		},
		methods: {
			//打印
			printEvent() {
				this.$nextTick(() => {
					this.$refs.prints.prints();
					this.$refs.prints.print();
				})
			},
			//同意
			agreed(row) {
				this.$confirm('是否确定同意积分兑换！', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					this.$api.post("/api/order/statusOrderCoin", {
						id: row.id,
						status: 1
					}, res => {
						if (res.status == 200) {
							this.$message.success(res.msg);
							this.getData(this.enquiryForm)
						} else {
							this.$message.error(res.msg);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//驳回
			overruled(row) {
				this.$confirm('是否确定驳回积分兑换！', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post("/api/order/statusOrderCoin", {
						id: row.id,
						status: 2
					}, res => {
						if (res.status == 200) {
							this.$message.success(res.msg);
							this.getData(this.enquiryForm)
						} else {
							this.$message.error(res.msg);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//查询风控系统
			chInfo(row) {
				this.subordinateId = row.user_id
				this.subordinateState = true;
			},
			// 主页面部分
			//搜索
			handleSearch(searchForm) {
				searchForm.page = 1;
				this.getData(searchForm);
			},
			//重置
			Reset(searchForm) {
				searchForm.page = 1;
				searchForm.user_id = '';
				searchForm.agent = '';
				this.getData(searchForm);
			},
			//分页
			handleCurrentChange(page) { //当前选中页
				this.enquiryForm.page = page;
				this.getData(this.enquiryForm);
			},
			handleSizeChange(limit) { //条数
				this.enquiryForm.page_size = limit;
				this.enquiryForm.page = 1;
				this.getData(this.enquiryForm);
			},
			//获取数据
			getData(params) { //初始化数据
				this.loading = true;
				this.$api.post("/api/order/orderCoinList?page=" + params.page, params, res => {
					if (res.status == 200) {
						let tableData = res.data;
						this.total = tableData.total; //总数
						this.tableData = tableData.list;
						this.tableData.forEach(item => { //状态转换
							switch (item.order_status) {
								case '10':
									item.order_status = "待处理";
									break;
								case '20':
									item.order_status = "已打款";
									break;
								case '30':
									item.order_status = "已拒绝";
									break;
								case '40':
									item.order_status = "已驳回";
									break;
								default:
									break;
							}
						});
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			// 导出
			exportData() {
				let th = ['ID', '所属机构', '申请人', '申请人电话', '申请积分', '提交时间'];
				let excelData = ['id', 'org_name', 'creator', 'mobile_phone', 'coin', 'create_time'];
				let data = this.formatJson(excelData, this.tableData);
				let defaultTitle = '导出文件';
				export_json_to_excel(th, data, defaultTitle)
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			// 表单部分
			// 代理商选择页面显示（表单显示）
			mechanismSearch() {
				this.mechanismVisible = true;
				this.getDialogData(this.dialogForm);
			},
			//表单分页
			handleCurrentChange1(page) { //当前选中页
				this.dialogForm.page = page;
				this.getDialogData(this.dialogForm);
			},
			handleSizeChange1(limit) { //表单条数
				this.dialogForm.page_size = limit;
				this.dialogForm.page = 1;
				this.getDialogData(this.dialogForm);
			},
			//表单获取数据
			getDialogData(params) { //初始化数据
				this.loading2 = true;
				this.$api.post("/api/agent/getUserAgent?page=" + params.page, params, res => {
					if (res.status == 200) {
						let dialogData = res.data;
						this.dialogTotal = dialogData.total; //总数
						this.dialogData = dialogData.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading2 = false;
				})
			},
			//获取每行
			singleElection(row) {
				this.templateSelection = row.id;
				this.checkList = row;
			},
			//取消
			cancelClick2() {
				this.checkList = [];
				this.templateSelection = '';
			},
			// 表单确定
			submitForm2() {
				this.enquiryForm.agent = this.checkList.user_name;
				this.enquiryForm.user_id = this.checkList.id;
				this.handleSearch2(this.dialogForm);
				this.cancelClick2();
				this.mechanismVisible = false;
				this.handleSearch(this.enquiryForm);
			},
			//表单取消
			cancelDialog2() {
				this.handleSearch2(this.dialogForm);
				this.cancelClick2();
				this.mechanismVisible = false;
			},
			//表单搜索
			handleSearch1(dialogForm) {
				dialogForm.page = 1;
				this.getDialogData(dialogForm);
			},
			//表单重置
			handleSearch2(dialogForm) {
				dialogForm.page = 1;
				dialogForm.mobile_phone = '';
				dialogForm.user_name = '';
				this.getDialogData(dialogForm);
			},
		}
	}
</script>

<style scoped>
	/deep/ .el-form-item__content .el-input-group {
		vertical-align: middle !important;
	}

	.code {
		cursor: pointer;
	}

	.code:hover {
		color: blue;
		text-decoration: underline;
	}
</style>
